import React, { useEffect, useState, useContext } from 'react'
import { useVideo } from '../context/video/VideoContext';
import { GlobalContext } from '../GlobalContext'
import { Link, useNavigate, useParams } from "react-router-dom"
import Modal from './Modal'
import Button from '../formfields/Button'
import { subscribe } from "../utils/pubsub"
import Spinner from './Spinner'
import EnabledDisabled from '../formfields/EnabledDisabled';
import { useVoice } from '../context/voice/VoiceContext';
import VoiceModeToggle from '../shared-components/VoiceModeToggle';
import { useTranslation } from 'react-i18next'
import SwitchLanguage from './SwitchLanguage';




type Props = {
  loggedIn: Boolean | string
  setLoggedIn: React.Dispatch<React.SetStateAction<any>>
  setUserData: React.Dispatch<React.SetStateAction<any>>
}


function Header({
  loggedIn,
  setLoggedIn,
  setUserData
}: Props) {



  const {
    tableData,
    userData,
    currentOrganisation,
    switchCurrentOrganisation,
    sendMessageToWebsocket,
    isVideoMode,
    isVideoPlaying,
    isInPhoneMode,
    setIsInPhoneMode,
    setIsVideoPlaying,
    handleLogout,
    isRTL,
    t
  } = useContext(GlobalContext)





  const navigate = useNavigate()
  const unsortedOrganisations = userData ? JSON.parse(userData.organisationsForUser) : {}
  const sortedOrganisationIds = unsortedOrganisations && Object.entries(unsortedOrganisations)
    .sort((a: any, b: any) => a[1].trim().localeCompare(b[1].trim()))
    .map(entry => entry[0])
  const [showMenu, setShowMenu] = useState(false)
  const [showOrgsMenu, setShowOrgsMenu] = useState(false)
  const [showCameraOptions, setShowCameraOptions] = useState(false)
  const [showZoomOptions, setShowZoomOptions] = useState(false)
  const { availableCameras, selectedCamera, selectCamera, cameraState, zoom, setZoom, longExposureMode, setLongExposureMode } = useVideo()
  const urlPath = window.location.pathname
  const urlPathArray = urlPath.split('/')
  const processId = urlPathArray[1] === 'process' && urlPathArray[2] ? urlPathArray[2] : null
  const processTitle = processId && tableData && tableData.ProcessDefinitions && tableData.ProcessDefinitions[processId]
    ? tableData.ProcessDefinitions[processId].DisplayName : null

  useEffect(() => {
    if (!showMenu) {
      setShowOrgsMenu(false)
    }
  }, [showMenu])


  const toggleVideo = (fieldName: string, enabled: boolean) => {
    setIsVideoPlaying(enabled)
  }

  return <div className={`${showMenu ? 'min-h-screen' : ''} z-20 w-full fixed flex flex-col`}>

    <header
      id={`logoHeader`}
      className={`
   ${isVideoMode && showMenu ? ' md:bg-transparent bg-brandblue ' : ''}
   ${!isVideoMode ? ' bg-brandblue ' : ''}
  flex items-center justify-center
    `}
      style={{
        height: '60px'
      }}
    >
      <div className={`
        max-w-3xl w-full px-5 text-white flex justify-between items-center gap-6
        ${isRTL ? ' flex-row-reverse' : '  flex-row '}
        `}>


        <div className={`
            ${processTitle ? ' w-1/5 ' : ' w-full '}
               ${isRTL ? ' items-end ' : '  items-start '}
            flex flex-col  justify-center
          `}>
          <Link to={'/'}>
            <img
              src={`/logos/logo-white-no-strapline.svg`}
              alt='ChecQR Logo'
              className={`border-0 py-1`}
              style={{ height: '45px' }}
              id={`checqrHeaderLogo`}
            />
          </Link>
        </div>



        {processTitle && <div className={`w-3/5`}>
          <h1 className={`text-center md:text-xl text-md font-righteous text-white py-2`}>
            {processTitle}
          </h1></div>}


        <div className={`
            ${processTitle ? ' w-1/5 ' : ' w-full '}
               ${isRTL ? ' items-start ' : '  items-end '}
            flex flex-col justify-center
          `}>
          <div className={`z-10 w-12  rounded-t
        ${!isVideoMode ? ' md:border-x-2 border-brandblue ' : ' '}
        ${!showMenu && isVideoMode ? ' pl-1 pt-1 ' : ' px-2 pt-2 '}
        ${showMenu ? ' bg-tealgreen ' : ' '} 
        `}
            style={{
              margin: '10px 0 0 0',
              height: '50px'
            }}
          >
            {showMenu &&
              <img
                src='/icons/close-x.svg'
                alt='Menu'
                id={'hamburgerCloseIcon'}
                className={`w-full cursor-pointer`}
                onClick={() => setShowMenu(false)} />}

            {!showMenu && isVideoMode && <img
              src='/icons/hamburger-brandblue.svg'
              alt='Menu'
              id={'hamburgerIcon'}
              className={`w-full cursor-pointer rounded bg-white`}
              style={{ padding: '6px' }}
              onClick={() => setShowMenu(true)} />
            }

            {!showMenu && !isVideoMode && <img
              src='/icons/hamburger.svg'
              alt='Menu'
              id={'hamburgerIcon'}
              className={`w-full cursor-pointer`}
              onClick={() => setShowMenu(true)} />
            }
          </div>
        </div>
      </div>
    </header>



    {showMenu && <div className={`md:h-auto h-full w-full absolute flex flex-col justify-center items-center text-sm text-white`}
      style={{ marginTop: '60px' }}
    >

      <div className={`
        h-full w-full flex flex-col  md:max-w-3xl md:px-5
          ${isRTL ? ' items-start ' : ' items-end '}
        `}>

        <div
          className={`
            ${isVideoMode ? '' : ' md:border-x-2 md:border-b-2 md:rounded-b border-brandblue '}
            md:max-w-sm w-full h-full bg-gradient-to-b from-tealgreen to-tealblue px-5 py-4 text-white flex flex-col gap-1 p-2`}
          onMouseLeave={() => setShowMenu(false)}
          style={{

          }}
        >

          {userData && <div className={`
          ${isRTL ? ' items-end ' : ' items-start '}
            flex flex-col pb-1 gap-1 text-brandblue
            `}>
            <div className={`
            ${isRTL ? 'flex-row-reverse' : 'flex-row'}
              flex gap-2 items-center`}>
              <img src='/icons/usericon-brandblue.svg' className={`w-5`} alt='' />
              <div className={`
            ${isRTL ? 'flex-row-reverse' : 'flex-row'}
                flex gap-0 flex-wrap items-center `}>
                <p className={`font-bold text-xl px-1`}>{userData.name}</p>
                {userData.email && <p className={`text-sm`}>({userData.email})</p>}
              </div>
            </div>

            {loggedIn === 'guest' && <p className={`text-sm`}>({t('UIElements.Header.guestUser')})</p>}

            {currentOrganisation && unsortedOrganisations && unsortedOrganisations[currentOrganisation] && <p className={`text-md`}>
              {unsortedOrganisations[currentOrganisation]}
            </p>}
          </div>}


   
            <SwitchLanguage
              selectedButtonClass='white'
              unSelectedButtonClass='primary'
            />



          <VoiceModeToggle />


          {isVideoMode && !isVideoPlaying && <Button
            text={t('UIElements.Header.startVideo')}
            onClick={() => setIsVideoPlaying(true)}
            size={'big'}
            variant={'white'}
            align={isRTL ? 'right' : 'left'}
          />}

          {isVideoMode && isVideoPlaying && <Button
            text={t('UIElements.Header.stopVideo')}
            onClick={() => setIsVideoPlaying(false)}
            size={'big'}
            variant={'white'}
            align={isRTL ? 'right' : 'left'}
          />}





          {currentOrganisation && availableCameras && availableCameras.length > 0 && <div>
            <div
              className={`bg-brandblue font-bold text-lg px-5 py-3 rounded hover:opacity-90`}>

              <div className={`
                flex  items-center gap-2
                ${isRTL ? 'flex-row-reverse' : 'flex-row'}
              `} onClick={() => setShowCameraOptions(!showCameraOptions)}>
                <p className={``}>{t('UIElements.Header.switchCamera')}</p>     <img src='/icons/arrow.svg' alt=''
                  className={`
                  h-3 
                  ${showCameraOptions && 'rotate-90'}
                ${isRTL && !showCameraOptions ? ' rotate-180 ' : ' '}
                `} />
              </div>

              {showCameraOptions &&
                <div className={`${isRTL ? ' text-right ' : ' text-left '} pt-2 text-sm`}>
                  {
                    availableCameras.map((camera, index) => {
                      let isCurrentlySelected = false
                      let isCurrentlyRunning = false

                      if (selectedCamera == camera.deviceId) {
                        isCurrentlySelected = true
                        if (cameraState === 'RUNNING') {
                          isCurrentlyRunning = true
                        }
                      }

                      return <div
                        key={index}
                        className={`${isCurrentlySelected ? '' : 'underline'} py-1 font-normal`}
                        onClick={() => {
                          setShowMenu(false)
                          selectCamera(camera.deviceId)
                        }}
                      >
                        {`${isCurrentlyRunning ? '🔴' : ''} ${camera.label}`}
                      </div>
                    })
                  }
                </div>}
            </div>
          </div>}






          {isVideoMode && isVideoPlaying && <div
            className={`bg-brandblue font-bold text-lg px-5 py-3 rounded hover:opacity-90`}>

            <div className={`
            flex items-center gap-2
                ${isRTL ? 'flex-row-reverse' : 'flex-row'}
            `}
              onClick={() => setShowZoomOptions(!showZoomOptions)}>
              <p className={``}>{t('UIElements.Header.zoom')}</p>
              <img src='/icons/arrow.svg' alt=''
                className={`
                  h-3 
                  ${showZoomOptions && 'rotate-90'}
                ${isRTL && !showZoomOptions ? ' rotate-180 ' : ' '}
                `} />
            </div>

            {showZoomOptions && <>
              <div className={`p-2 flex flex-row gap-1`}>
                <Button
                  text={`100%`}
                  onClick={() => setZoom(1)}
                  size={'small'}
                  variant={zoom === 1 ? 'secondary' : 'white'}
                />
                <Button
                  text={`150%`}
                  onClick={() => setZoom(1.5)}
                  size={'small'}
                  variant={zoom === 1.5 ? 'secondary' : 'white'}
                />
                <Button
                  text={`200%`}
                  onClick={() => setZoom(2)}
                  size={'small'}
                  variant={zoom === 2 ? 'secondary' : 'white'}
                />
              </div>
              <div className={`p-2 flex flex-row gap-1`}>
                <Button
                  text={t('UIElements.Header.normalExposure')}
                  onClick={() => setLongExposureMode(false)}
                  size={'small'}
                  variant={!longExposureMode ? 'secondary' : 'white'}
                />
                <Button
                  text={t('UIElements.Header.longExposure')}
                  onClick={() => setLongExposureMode(true)}
                  size={'small'}
                  variant={longExposureMode ? 'secondary' : 'white'}
                />
              </div>

            </>
            }
          </div>}



          {switchCurrentOrganisation && Object.keys(unsortedOrganisations).length > 1 && <div>
            <div
              className={`bg-brandblue font-bold text-lg py-3 rounded hover:opacity-90`}>

              <div className={`
                flex  items-center px-5 gap-2
                ${isRTL ? 'flex-row-reverse' : 'flex-row'}
                `} onClick={() => setShowOrgsMenu(!showOrgsMenu)}>
                <p className={``}>{t('UIElements.Header.switchOrganisation')}</p>
                <img src='/icons/arrow.svg' alt=''
                  className={`
                  h-3 
                  ${showOrgsMenu && 'rotate-90'}
                ${isRTL && !showOrgsMenu ? ' rotate-180 ' : ' '}
                `} />
              </div>

              {unsortedOrganisations && sortedOrganisationIds && switchCurrentOrganisation && showOrgsMenu &&
                <div className={`${isRTL ? ' text-right ' : ' text-left '} pt-2 text-sm overflow-y-auto px-5`}
                  style={{ maxHeight: '30vh' }}>
                  {
                    sortedOrganisationIds.map((id: string, index: number) => {
                      return <div
                        className={`${currentOrganisation === id && 'hidden'} underline py-1 font-normal`}
                        key={index}
                        onClick={() => {
                          setShowMenu(false)
                          switchCurrentOrganisation(id, true)
                          navigate('/')
                        }}>
                        {unsortedOrganisations[id]}
                      </div>
                    })
                  }
                </div>}
            </div>
          </div>}

          {currentOrganisation && loggedIn !== 'externalUser' && <>
            <Button
              onClick={() => {
                setShowMenu(false)
                navigate('/checklists')
              }}
              text={t('UIElements.Header.allChecklists')}
              variant={`primary`}
              align={isRTL ? 'right' : 'left'}
              size={'big'}
            />

            <Button
              onClick={() => {
                setShowMenu(false)
                navigate('/processes')
              }}
              text={t('UIElements.Header.allProcesses')}
              variant={`primary`}
              align={isRTL ? 'right' : 'left'}
              size={'big'}
            />


            <Button
              onClick={() => {
                setShowMenu(false)
                navigate(`/scan-qr-code`)
              }}
              text={t('UIElements.Header.scanQRCode')}
              variant={`primary`}
              align={isRTL ? 'right' : 'left'}
              size={'big'}
            />
          </>}



          <Button
            onClick={handleLogout}
            text={t('UIElements.Header.logOut')}
            variant={`primary`}
            align={isRTL ? 'right' : 'left'}
            size={'big'}
          />
        </div>
      </div>
    </div>}
  </div>
}
export default Header